module.exports = __webpack_public_path__ + "img/operation.b78d74c4.png";